import RecipeInfo from './RecipeInfo';

export default RecipeInfo;
